import {
	Avatar as MatAvatar,
} from '@material-ui/core';
import styled from 'styled-components';

export const UiButtonBox = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const UiAvatar = styled(MatAvatar)`
	margin: auto;
`;
